export function pickVideoSource(sources) {
    if (!sources || sources.length === 0)
        return undefined;
    const mp4Sources = sources.filter(s => /\.mp4(\?|$)/i.test(s.url));
    const isDesktop = typeof window === 'undefined' || window.innerWidth >= 768;
    const find = (pattern) => mp4Sources.find(s => pattern.test(s.url));
    return (isDesktop
        ? find(/720p/i) || find(/1080p/i) || find(/SD-480p|-480p/i)
        : find(/SD-480p|-480p/i) || find(/720p/i) || find(/1080p/i)) || mp4Sources[0] || sources[0];
}
